import { httpApi } from '@api/http.api';

export const getServerTime = (): Promise<string> => httpApi.get<string>('date').then(({ data }) => data);
